var _a;
const u = up.util;
const e = up.element;
up.ResponseDoc = (_a = class ResponseDoc {
        constructor({ document, fragment, content, target, origin, data, cspInfo, match }) {
            if (document) {
                this._parseDocument(document, origin, data);
            }
            else if (fragment) {
                this._parseFragment(fragment, origin, data);
            }
            else {
                this._parseContent(content || '', origin, target, data);
            }
            this._cspInfo = cspInfo;
            up.script.warnOfUnsafeCSP(cspInfo);
            if (origin) {
                let originSelector = up.fragment.tryToTarget(origin);
                if (originSelector) {
                    this._rediscoveredOrigin = this.select(originSelector);
                }
            }
            this._match = match;
        }
        _parseDocument(value, origin, data) {
            if (value instanceof Document) {
                this._document = value;
                this._isFullDocument = true;
            }
            else if (u.isString(value)) {
                this._isFullDocument = e.isFullDocumentHTML(value);
                let htmlParser = (html) => [e.createBrokenDocumentFromHTML(html)];
                let nodes = up.fragment.provideNodes(value, { origin, data, htmlParser });
                if (nodes[0] instanceof Document) {
                    this._document = nodes[0];
                }
                else {
                    this._document = this._buildFauxDocument(nodes);
                }
            }
            else {
                this._document = this._buildFauxDocument(value);
            }
        }
        _parseFragment(value, origin, data) {
            let element = e.extractSingular(up.fragment.provideNodes(value, { origin, data }));
            this._document = this._buildFauxDocument(element);
        }
        _parseContent(value, origin, target, data) {
            if (!target)
                up.fail("must pass a { target } when passing { content }");
            let simplifiedTarget = u.map(up.fragment.parseTargetSteps(target), 'selector').join();
            let nodes = up.fragment.provideNodes(value, { origin, data });
            let matchingElement = e.createFromSelector(simplifiedTarget, { content: nodes });
            this._document = this._buildFauxDocument(matchingElement);
        }
        _buildFauxDocument(nodes) {
            nodes = u.wrapList(nodes);
            let fauxDocument = document.createElement('up-document');
            fauxDocument.append(...nodes);
            return fauxDocument;
        }
        rootSelector() {
            return up.fragment.toTarget(this._document.children[0]);
        }
        get title() {
            return this._fromHead(this._getTitleText);
        }
        _getHead() {
            if (this._isFullDocument) {
                return this._document.head;
            }
        }
        _fromHead(fn) {
            let head = this._getHead();
            return head && fn(head);
        }
        get metaTags() {
            return this._fromHead(up.history.findMetaTags);
        }
        get assets() {
            return this._fromHead((head) => {
                let assets = up.script.findAssets(head);
                return u.map(assets, (asset) => {
                    asset = e.revivedClone(asset);
                    up.script.adoptDetachedHeadAsset(asset, this._cspInfo);
                    return asset;
                });
            });
        }
        get lang() {
            if (this._isFullDocument) {
                return up.history.getLang(this._document);
            }
        }
        _getTitleText(head) {
            return head.querySelector('title')?.textContent;
        }
        select(selector) {
            let finder = new up.FragmentFinder({
                selector: selector,
                origin: this._rediscoveredOrigin,
                document: this._document,
                match: this._match,
            });
            return finder.find();
        }
        selectSteps(steps) {
            return steps.filter((step) => {
                return this._trySelectStep(step) || this._cannotMatchStep(step);
            });
        }
        commitSteps(steps) {
            return steps.filter((step) => this.commitElement(step.newElement));
        }
        _trySelectStep(step) {
            if (step.newElement) {
                return true;
            }
            let newElement = this.select(step.selector);
            if (!newElement) {
                return;
            }
            let { selectEvent } = step;
            if (selectEvent) {
                selectEvent.newFragment = newElement;
                selectEvent.renderOptions = step.originalRenderOptions;
                up.emit(step.oldElement, selectEvent, { callback: step.selectCallback });
                if (selectEvent.defaultPrevented) {
                    return;
                }
            }
            step.newElement = newElement;
            return true;
        }
        _cannotMatchStep(step) {
            if (!step.maybe) {
                throw new up.CannotMatch();
            }
        }
        commitElement(element) {
            if (this._document.contains(element)) {
                up.script.adoptNewFragment(element, this._cspInfo);
                element.remove();
                return true;
            }
        }
        finalizeElement(element) {
            if (this._document instanceof Document) {
                for (let brokenElement of e.subtree(element, ':is(noscript, script, audio, video):not(.up-keeping, .up-keeping *)')) {
                    let clone = e.revivedClone(brokenElement);
                    brokenElement.replaceWith(clone);
                }
            }
        }
    },
    (() => {
        u.memoizeMethod(_a.prototype, {
            _getHead: true,
        });
    })(),
    _a);
